import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { Spacer } from '../../common/components/Spacer';
import { BranchArrow } from '../../common/components/StatusDiagram/BranchArrow';
import { Status } from '../../common/components/StatusDiagram/Status';
import { SectionHeading } from '../../common/components/styledComponents';
import { StatusMessage } from '../UploadedImages/StatusMessage';

const DiagramSection = styled.div`
  width: 100%;
`;

export const StatusDiagram = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.mypage.uploadedImages.diagram',
  });

  return (
    <DiagramSection>
      <SectionHeading>{t('heading')}</SectionHeading>
      <Spacer height="20px" />
      <Status
        statusMessage={<StatusMessage status="PENDING" />}
        description={t('description.pending')}
      />
      <Status
        branch={<BranchArrow hasNext />}
        statusMessage={<StatusMessage status="DECLINED" />}
        description={t('description.declined')}
      />
      <Status
        branch={<BranchArrow />}
        statusMessage={<StatusMessage status="FAILED" />}
        description={t('description.failed')}
      />
      <Status
        statusMessage={<StatusMessage status="COMPLETED" />}
        description={t('description.completed')}
      />
      <Spacer height="5px" />
      <Status
        statusMessage={<StatusMessage status="RESERVED" />}
        description={t('description.reserved')}
      />
    </DiagramSection>
  );
};
